var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-spacer", attrs: { id: "credit-card" } },
    [
      _c("ViewHeader", { attrs: { title: "Credit Card Payment" } }),
      _c(
        "div",
        { staticClass: "drop-shadow-sides", attrs: { id: "rest-of-body" } },
        [
          _c("TotalDetail", { attrs: { isTipVisible: true } }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.ccFormLoaded,
                  expression: "ccFormLoaded",
                },
              ],
              staticClass: "view-content",
            },
            [
              _c(
                "form",
                { ref: "cc-form", attrs: { id: "cc-form", novalidate: "" } },
                [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { attrs: { for: "cc-number" } }, [
                      _vm._v("Credit Card Number"),
                    ]),
                    _c("div", {
                      staticClass: "braintree-form-control",
                      attrs: { id: "cc-number" },
                    }),
                    !_vm.isNumberValid
                      ? _c("div", { staticClass: "error-message" }, [
                          _vm._v(" Invalid credit card number. "),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "inline" }, [
                      _c("label", { attrs: { for: "cc-expiration" } }, [
                        _vm._v("Expiration Date"),
                      ]),
                      _c("div", {
                        staticClass: "braintree-form-control",
                        attrs: { id: "cc-expiration" },
                      }),
                      !_vm.isExpirationValid
                        ? _c("div", { staticClass: "error-message" }, [
                            _vm._v(" Invalid date. "),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "inline" }, [
                      _c("div", { attrs: { id: "cc-cvv-label" } }, [
                        _c("div", [
                          _c("label", { attrs: { for: "cc-cvv" } }, [
                            _vm._v(_vm._s(_vm.cvvLabel)),
                          ]),
                        ]),
                        _vm._v("  "),
                        _c(
                          "div",
                          {
                            staticClass: "info-mark",
                            on: { click: _vm.showCvvInfo },
                          },
                          [_vm._v("?")]
                        ),
                      ]),
                      _c("div", {
                        staticClass: "braintree-form-control",
                        attrs: { id: "cc-cvv" },
                      }),
                      !_vm.isCvvValid
                        ? _c("div", { staticClass: "error-message" }, [
                            _vm._v(" Invalid CVV code. "),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { attrs: { for: "cc-name" } }, [
                      _vm._v("Name on Card"),
                    ]),
                    _c("input", {
                      ref: "cc-name",
                      staticClass: "input-secondary",
                      attrs: { id: "cc-name", type: "text", required: "" },
                    }),
                    !_vm.isNameValid
                      ? _c("div", { staticClass: "error-message" }, [
                          _vm._v(" Name on card is required. "),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "button-primary",
                      attrs: { type: "submit" },
                    },
                    [
                      _vm._v(" Pay with "),
                      _c("span", { attrs: { id: "card-brand" } }, [
                        _vm._v(" " + _vm._s(_vm.cardType) + " "),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }